function InputFileImg({ noImg, setNoImg, setCustomImg }) {

	const handleImage = e => {
		const reader = new FileReader();
		reader.onload = () => {
			if(reader.readyState === 2) {
				setCustomImg(reader.result);
			}
		}
		reader.readAsDataURL(e.target.files[0]);
	}
  
	return ( 
		<>
			<label htmlFor="file">Subir imagen personalizada</label>		
			<input
				id="file"
				name="file"
				type="file"
				accept="image/png, image/jpeg"
				onChange={handleImage}
				disabled={noImg}
				style={{ cursor:"pointer"}}
			/>
  
			<input
				id="noImg"
				name="noImg"
				type="checkbox"
				value={noImg}
				checked={noImg}
				onClick={()=>setNoImg(!noImg)}
				style={{ cursor:"pointer"}}
			/>
			<label htmlFor="noImg">Sin imagen</label>
		</>
	);
}

export default InputFileImg;